import "../node_modules/font-awesome/css/font-awesome.min.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/aos/dist/aos.css";
import "../node_modules/aos/dist/aos.js";
import "../node_modules/slick-carousel/slick/slick.css";
import "../node_modules/slick-carousel/slick/slick-theme.css";
import "remixicon/fonts/remixicon.css";
import { useLocation } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import "./App.css";
import { lazy } from "react";

const AdminLayout = lazy(() => import("./admin/layout/adminLayout.js"));
const ClientLayout = lazy(() => import("./client/layout/clientLayout.js"));

/**
 * Description: Main application component that renders both admin and client layouts.
 * Acts as the root component combining the administrative dashboard and public-facing client interface.
 * @returns {React.ReactElement} JSX element containing admin and client layout sections.
 */
function App() {
  const { pathname } = useLocation();
  const Layout = pathname.includes("admin") ? AdminLayout : ClientLayout;

  return (
    <PrimeReactProvider value={{ unstyled: false, ripple: true }}>
      <Layout />
    </PrimeReactProvider>
  );
}

export default App;
